import { render } from "./EvidenceSourcePanel.vue?vue&type=template&id=c32badde&scoped=true"
import script from "./EvidenceSourcePanel.vue?vue&type=script&lang=js"
export * from "./EvidenceSourcePanel.vue?vue&type=script&lang=js"

import "./EvidenceSourcePanel.vue?vue&type=style&index=0&id=c32badde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c32badde"]])

export default __exports__